export default __webpack_public_path__ + "fonts/SuisseWorks-Regular-WebXL.woff2";